import { useModal } from '@/hooks/modals/useModal';
import { ModalsKey } from '@/enums/modalsKey';
import { ModalHeader } from '@starsoft/common/components';
import ClaimBonusModalLayout from '../../ClaimRewardModal/Layout';
import ClaimBonusModalContent from './Content';
import { useUserBonusByIdWithParams } from '@/hooks/user-bonus/useUserBonusByIdWithParams';
import { useLanguageDictionary } from '@/hooks/useLanguageDictionary';
import { I18n } from '@/services/I18n';
import { useSearchParams } from '@starsoft/common/hooks';

export default function ClaimBonusModal() {
  const { handleContainer, isOpen, onClose, setSearchParams } = useModal(
    ModalsKey.ClaimBonus,
  );
  const { isLoading, userBonus } = useUserBonusByIdWithParams();
  const nameI18n: I18n = useLanguageDictionary(userBonus?.bonus?.name);
  const params: URLSearchParams = useSearchParams();
  const bonusId: string = params.get('user_bonus_id');

  return (
    <ClaimBonusModalLayout
      handleContainer={handleContainer}
      isOpen={isOpen && !!bonusId}
      onClose={onClose}
      setSearchParams={setSearchParams}
    >
      <ModalHeader
        title={nameI18n.t()}
        onClose={onClose}
        isLoading={isLoading}
        smallMobilePadding
      />
      <ClaimBonusModalContent />
    </ClaimBonusModalLayout>
  );
}
